'use client'

import { memo, useMemo } from 'react'
import styled from 'styled-components'
import { designGrid, mq } from '@/styles'
import type { TypeCmsPage } from '@/schema'
import { SectionContents } from './SectionContents'


interface TypeMainContents {
  data: TypeCmsPage['contents']
}


// const getContentsSections = (sections) => sections.map((section, idx) => {
//   return (
//     <SectionContents key={idx} section={section} />
//   )
// })
// CMS HACK
// added hack to simulate content with 2 rows ( not yet ready in the CMS)

const getContentsSections = (sections = []) => {
  let jumpIdx = null
  return sections.map((section, idx) => {

    if (jumpIdx && jumpIdx === idx) {
      jumpIdx = null
    } else {
      let columnsGrouped = null

      if(section.rows === 2) {
        jumpIdx = idx + 1
        const nextSectionColumns = sections[idx + 1]?.columns
        columnsGrouped = [...section.columns, ...nextSectionColumns]
      }

      return (
        <SectionContents key={idx} section={columnsGrouped ? { rows: section.rows, columns: columnsGrouped } : section} />
      )
    }
  })
}

export const MainContents = memo(({ data }:TypeMainContents) => {
  const ContentsSections = useMemo(() => getContentsSections(data), [data])

  return (
    <Main>
      {ContentsSections}
    </Main>
  )
})

const Main = styled.main`
  ${designGrid({})}
  flex-grow: 2;

  ${mq.greaterThan('desktop-large')} {
    margin: 0 auto;
    max-width: var(--page-container-max-width);
  }

  .marquee {
    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 12;
      left: calc(-50vw + 50%);
      position: relative;
      width: 100vw;
      width: 100dvw;
    }
  }

  /* HARDOCED BLOCK UNTIL UPDATE IN CMS */
  .feria {
    display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;

    > a {
      background-image: unset;
      background-position: unset;
      background-repeat: unset;
      background-size: unset;
      flex-shrink: 0;
      position: unset;
      transition: unset;
      width: 130px;

      ${mq.greaterThan('desktop')} {
        width: 200px;
      }

      &:nth-of-type(4) {
        width: 170px;

        ${mq.greaterThan('desktop')} {
          width: 260px
        }
      }

      &:hover,
      &.active {
        background-size: unset;
      }
    }
  }
`
